var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDropdown = function SvgArrowDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4 4 4-4H0z"
  })));
};
export default SvgArrowDropdown;